import React, { useState, useEffect } from "react";
import { useSelector, useDispatch } from "react-redux";
import { updateDataSearchLichSuBank } from "../../../actions/TichHopBank/DanhSachTaiKhoanBank";
import { PopoversBootrap } from "components/GenericComponent/PopoversBootrap";
import DateTimePicker from "components/GenericComponent/DateTimePicker";
import { formatDayMonth, currentDate, convertDate } from "utils/formatDate";
import dsBankApi from "service/TichHopBank/dsBankApi";

export const SearchBarDesktop = ({ onSearch }) => {
  const dispatch = useDispatch();

  const dataSearch = useSelector((state) => state.dataSearchLichSuBank);
  const [dataBank, setDataBank] = useState({});

  const onChangeDate = (field) => (evt) => {
    updateState(field, formatDayMonth(evt));
    console.log(evt);
  };
  const updateSelect = () => (e) => {
    updateState("sSoTaiKhoan", e.target.value);
  };
  const updateState = (field, text) => {
    dispatch(
      updateDataSearchLichSuBank({
        ...dataSearch,
        [field]: text,
      })
    );
  };

  useEffect(() => {
    dsBankApi
      .list({
        sSearch: "",
        sMaNganHang: "",
        iPageSize: -1,
        iPageIndex: -1,
        isKhoa: 0,
        isDangKyNhanPushBDSD: null,
      })
      .then((response) => {
        if (response.status == "200") {
          setDataBank(response.data);
        } else {
        }
      });
  }, []);

  // convert sự kiện tìm kiếm từ ngày đến ngày
  var dateFrom = currentDate();
  if (dataSearch.TuNgay === "01/01/2001") dateFrom = "";
  else dateFrom = dataSearch.TuNgay;
  var dateTo = currentDate();
  if (dataSearch.DenNgay === "01/01/4000") dateTo = "";
  else dateTo = dataSearch.DenNgay;
  dateTo = convertDate(dateTo);
  dateFrom = convertDate(dateFrom);
  return (
    <>
      <div className="search-new hidden-mobile-main show-table-main">
        <div className="input-sm-new input-new-18">
          <label className="font-color-default font-bold">Số tài khoản</label>
          <select
            class="form-control input-sm"
            value={dataSearch.sSoTaiKhoan}
            onChange={updateSelect()}
          >
            <option value="">-- Tất cả --</option>
            {dataBank &&
              typeof dataBank.List !== "undefined" &&
              dataBank.List.map((item, idx) => (
                <option key={"comboBank" + idx} value={item.SoTaiKhoan}>
                  {item.MaNganHang + " - " + item.SoTaiKhoan}
                </option>
              ))}
          </select>
        </div>
        <div className="input-sm-new input-new-18">
          <label className="font-color-default font-bold">Từ ngày</label>
          <DateTimePicker
            value={dateFrom}
            onChange={onChangeDate("TuNgay")}
            placeholder="Từ ngày"
            name="tuNgay"
            className="form-control input-sm"
          ></DateTimePicker>
        </div>

        <div className="input-sm-new input-new-18">
          <label className="font-color-default font-bold">Đến ngày</label>
          <DateTimePicker
            value={dateTo}
            onChange={onChangeDate("DenNgay")}
            placeholder="Đến ngày"
            name="dateFrom"
            className="form-control input-sm"
          ></DateTimePicker>
        </div>

        <div className="input-sm-new input-new-18 search-main-new">
          <button
            type="submit"
            className="btn btn-info-new btn-seach-ds"
            onClick={onSearch}
          >
            <i className="la la-search"></i>
            <span> &nbsp; Tìm kiếm&nbsp;</span>
          </button>
        </div>
      </div>
    </>
  );
};
